import _defineProperty from "@babel/runtime/helpers/defineProperty";
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import getColStyle from 'react-grid-system/build/grid/Col/style';
import CommonPropTypes from "./PropTypes";
const DEFAULT_GRID_COLUMNS = 12;
export default class StatelessCol extends Component {
  render() {
    const {
      children,
      className,
      xs,
      sm,
      md,
      lg,
      xl
    } = this.props;
    const style = getColStyle({
      width: {
        xs,
        sm,
        md,
        lg,
        xl
      },
      screenClass: this.props.screenClass,
      gutterWidth: this.props.gutterWidth,
      gridColumns: DEFAULT_GRID_COLUMNS,
      moreStyle: {
        overflow: 'visible'
      }
    });
    return /*#__PURE__*/React.createElement("div", {
      className: className,
      style: style
    }, children);
  }
}
_defineProperty(StatelessCol, "propTypes", {
  children: PropTypes.node,
  className: PropTypes.string,
  screenClass: CommonPropTypes.screenClass.isRequired,
  gutterWidth: PropTypes.number,
  xs: PropTypes.number,
  sm: PropTypes.number,
  md: PropTypes.number,
  lg: PropTypes.number,
  xl: PropTypes.number
});
_defineProperty(StatelessCol, "defaultProps", {
  children: null,
  xs: 12,
  sm: 12,
  md: 12,
  lg: 12,
  xl: 12
});